/* eslint-disable max-lines */
/* eslint-disable camelcase */
/* eslint-disable max-depth */
/* eslint-disable operator-linebreak */
/* eslint-disable max-statements */
/* eslint-disable no-magic-numbers */

export default {
    tableDataItems: [
        {
            prop: 'senderDetailAddr',
            label: '站点名称',
            type: 'normal'
        },
        {
            prop: 'senderDetailAddrAll',
            label: '站点地址',
            type: 'normal'
        },
        {
            prop: 'taskCount',
            label: '单量',
            type: 'normal'
        },
        {
            prop: 'totalGrossWeight',
            label: '总重量(kg)',
            type: 'normal'
        },
        {
            prop: 'totalVolume',
            label: '总方量(m³)',
            type: 'normal'
        }
    ],
    tableListsDataItems: [
        {
            prop: 'receiverDetailAddr',
            label: '站点名称',
            type: 'normal'
        },
        {
            prop: 'receiverDetailAddrAll',
            label: '站点地址',
            type: 'normal'
        },
        {
            prop: 'taskCount',
            label: '单量',
            type: 'normal'
        },
        {
            prop: 'totalGrossWeight',
            label: '总重量(kg)',
            type: 'normal'
        },
        {
            prop: 'totalVolume',
            label: '总方量(m³)',
            type: 'normal'
        }
    ]
};
